/**
 * SignupPage — autenticazione Phase 5 (IMPL-P5-011).
 *
 * Wraps the registration form inside the standard auth chrome
 * (`AuthLayout` + `AuthCard`). On a successful submit we stash the email in
 * sessionStorage so the confirm page can display it, then navigate to
 * `/registrati/conferma`.
 */
import { Link, useNavigate } from 'react-router-dom';
import { AuthLayout } from '../components/AuthLayout';
import { AuthCard } from '../components/AuthCard';
import { RegistrationForm } from '../components/RegistrationForm';

const SIGNUP_EMAIL_KEY = 'auth.signup.email';

export function SignupPage() {
  const navigate = useNavigate();

  function handleSuccess(email: string) {
    try {
      sessionStorage.setItem(SIGNUP_EMAIL_KEY, email);
    } catch {
      /* sessionStorage might be unavailable in private mode — ignore. */
    }
    navigate('/registrati/conferma', { replace: true });
  }

  return (
    <AuthLayout>
      <AuthCard
        title="Crea il tuo account"
        description="Registrati per accedere al portale di registrazione contratti."
        footer={
          <p className="text-muted-foreground">
            Hai già un account?{' '}
            <Link to="/accedi" className="font-medium text-primary underline-offset-4 hover:underline">
              Accedi
            </Link>
          </p>
        }
      >
        <RegistrationForm onSuccess={handleSuccess} />
      </AuthCard>
    </AuthLayout>
  );
}

export { SIGNUP_EMAIL_KEY };
